import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid } from '../cacheUtils';
import Settings from 'settings.json';

export const fetchPlans = createAsyncThunk(
  'plans/fetchPlans',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().plans;

    if (isCacheValid(state.lastFetched)) {
      return { data: state.data, cached: true };
    }

    try {
      const remoteServer = Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].remote_server;
      const response = await Axios.get(`${remoteServer}/api/account/plans`);
      const plans = response.data.data;

      let formatted = [];
      if (plans?.plans) {
        plans.plans.forEach(plan => {
          const label = `${plan.name} (${plan.currency.symbol}${plan.price}/${plan.interval})`;
          formatted.push({ value: plan.id, label });
        });
      }

      return {
        data: { list: formatted, active: plans?.active, raw: plans },
        cached: false,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch plans');
    }
  }
);

const plansSlice = createSlice({
  name: 'plans',
  initialState: {
    data: null,
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        if (!state.data) {
          state.loading = true;
        }
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        const { data, cached } = action.payload;
        if (!cached) {
          state.data = data;
          state.lastFetched = Date.now();
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidatePlansCache } = plansSlice.actions;
export default plansSlice.reducer;